"use strict";
// Code Generation Types and Interfaces
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppState = void 0;
var AppState;
(function (AppState) {
    AppState["INITIAL"] = "INITIAL";
    AppState["CODING"] = "CODING";
    AppState["CODE_READY"] = "CODE_READY";
})(AppState || (exports.AppState = AppState = {}));
